import React from "react";

import * as Layout from "~/Layout";
import { Time } from "~/Time";
import * as Typography from "~/Typography";

export type Props = Time.Interval & {
  readonly Start?: React.Fn<Time.DateTime>;
  readonly Separator?: React.Fn;
  readonly Stop?: React.Fn<Time.DateTime>;
  readonly Ongoing?: React.Fn;
  readonly Duration?: React.Fn<Time.Duration>;
};

export const Component = React.memo(
  ({
    Start = Default.DateTime,
    Separator = Default.Separator,
    Stop = Default.DateTime,
    Duration = Default.Duration,
    Ongoing = Default.Ongoing,
    interval,
  }: Props) => {
    const StopOrOngoing = () =>
      Time.Interval.when(
        { interval },
        {
          started: () => <Ongoing />,
          stopped: ({ interval }) => <Stop {...interval.stop} />,
        }
      );

    const duration = Time.Interval.Stopped.toDuration(
      Time.Interval.when(
        { interval },
        {
          started: Time.Interval.Started.toStopped(Time.DateTime.now()),
          stopped: (stopped) => stopped,
        }
      )
    );

    return (
      <Typography.Component>
        <Start {...interval.start} />
        <Separator />
        <StopOrOngoing />
        <Duration {...duration} />
      </Typography.Component>
    );
  },
  (a, b) => Time.Interval.equals(a, b)
);

namespace Default {
  export const DateTime = (dateTime: Time.DateTime) => (
    <Time.DateTime {...dateTime} />
  );

  export const Separator = () => (
    <Typography.Component>&nbsp;to&nbsp;</Typography.Component>
  );

  export const Duration = (duration: Time.Duration) => (
    <Layout.Block.Component>
      <Typography.Component small>
        {Time.Duration.toEnglish(duration)}
      </Typography.Component>
    </Layout.Block.Component>
  );

  export const Ongoing = () => (
    <Typography.Component strong>now</Typography.Component>
  );
}
